const twoFactorAuthPT = {
    "view": {
        "title": "Autenticação de Dois Fatores",
        "form": {
            "label": {
                "currentMethod": "Método Atual de Dois Fatores",
                "authenticatorSetupTitle": "Configure seu Aplicativo Autenticador",
                "scanInstructions": "Escaneie o código QR abaixo usando qualquer aplicativo autenticador TOTP (como Authy, Google Authenticator, Microsoft Authenticator etc).",
                "qrCodeAlt": "Código QR para configuração do autenticador",
                "step1": "Abra seu aplicativo autenticador.",
                "step2": "Selecione a opção para adicionar uma nova conta.",
                "step3": "Escolha a opção \"Escanear um código QR\" no aplicativo.",
                "step4": "Aponte a câmera do seu telefone para o código QR acima.",
                "step5": "Uma vez escaneado, o autenticador começará a gerar um Código OTP de 6 dígitos que atualiza a cada 30 segundos. Este Código OTP pode ser usado para completar o processo de login.",
                "appLinks": "Aqui estão os links para alguns aplicativos autenticadores comuns:",
                "appLinksAuthy": "Authy",
                "appLinksGoogle": "Google Authenticator",
                "appLinksMicrosoft": "Microsoft Authenticator",
                "googlePlay": "Google Play Store",
                "appStore": "Apple App Store",
                "loadingQrCode": "Carregando código QR...",
                "emailSetupTitle": "Autenticação de Dois Fatores por Email",
                "emailDescription": "Você receberá uma Senha de Uso Único (OTP) no seu endereço de email registrado, que pode ser usada para completar o processo de login. Certifique-se de verificar sua caixa de entrada de email ou pasta de spam para o OTP ao fazer login."
            },
            "help_text": {
                "currentMethod": "O email está atualmente definido como o método padrão para Autenticação de Dois Fatores. No entanto, recomendamos usar o método Autenticador para maior segurança."
            },
            "option": {
                "2faMethod": {
                    "selectMethod": "Selecione o Método 2FA",
                    "email": "Email",
                    "auth": "Autenticador"
                }
            },
            "button": {
                "save": "Salvar",
                "saving": "Salvando..."
            }
        },
        "backupCodes": {
            "title": "Códigos de Backup",
            "view": {
                "button": {
                    "generate": "Gerar Códigos de Backup",
                    "download": "Baixar Códigos de Backup"
                },
                "modal": {
                    "header": "Seus Códigos de Backup",
                    "body": {
                        "noCodes": "Nenhum código de backup disponível"
                    }
                }
            }
        }
    }
};

export default twoFactorAuthPT;